import IconDoubleChevronRight from '@apollo/icons/small/IconDoubleChevronRight.svg';
import { Button } from '@apollo/orbit';
import React from 'react';

import { useLocalStorage } from 'src/hooks/useLocalStorage';

interface Props {
  onOpen: () => void;
}

export const InsightsExpandButton = React.forwardRef<
  HTMLButtonElement | null,
  Props
>(({ onOpen }, ref) => {
  const [showExpandButtonSignal, setShowExpandButtonSignal] = useLocalStorage(
    'showExpandButtonSignal',
  );

  return (
    <Button
      ref={ref}
      variant="secondary"
      onClick={() => {
        onOpen();
        if (showExpandButtonSignal) setShowExpandButtonSignal(false);
      }}
      className="mb-3 mr-2 flex items-start"
      leftIcon={
        <span>
          <IconDoubleChevronRight />
          {showExpandButtonSignal ? (
            <div className="absolute -right-1 -top-1 size-2 rounded bg-notice" />
          ) : null}
        </span>
      }
      aria-label="Expand"
    />
  );
});
